import { useFormikContext } from "formik";
import React, { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import {
  FormSelectField,
  FormTextField,
} from "../../../../../partials/content/Forms/FormField";

function QuotationContact({
  customerContacts = [],
  customerContactDefault = false,
  handleCustomerContactDefault,
}) {
  const { values, setFieldValue } = useFormikContext();
  const [contactOptions, setContactOptions] = useState([]);
  useEffect(() => {
    setContactData(customerContacts);
  }, [customerContacts]);
  return (
    <Card>
      <Card.Header>
        <i className="fas fa-id-card-alt"></i>
        <span>
          {values.customerType === 2 ? (
            <strong>Customer Contact</strong>
          ) : (
            <strong>Lead Contact</strong>
          )}
        </span>
      </Card.Header>
      <Card.Body>
        <div className="row">
          {values.customerType === 2 ||
          typeof values.customerType === "undefined" ? (
            <div className="col-sm-12 col-md-12 col-lg-12">
              <FormSelectField
                label="Contact Reference"
                name="contact"
                options={contactOptions}
                onSelectChange={(contactValue) => {
                  setFieldValue("contact", contactValue);
                  setFieldValue("contactName", contactValue.contactName);
                  setFieldValue("position", contactValue.position);
                  setFieldValue("contactPhone", contactValue.contactPhone);
                  setFieldValue("contactEmail", contactValue.contactEmail);
                }}
              />
            </div>
          ) : null}
          <div className="col-sm-6 col-md-6 col-lg-6">
            <FormTextField label="Contact Name" name="contactName" />
            <FormTextField label="Position" name="position" />
          </div>
          <div className="col-sm-6 col-md-6 col-lg-6">
            <FormTextField label="Phone Number" name="contactPhone" />
            <FormTextField label="Email" name="contactEmail" />
          </div>
        </div>
      </Card.Body>
    </Card>
  );
  function setContactData(customerContacts = []) {
    let contactOptionsTmp = [];
    contactOptionsTmp.push({
      value: {
        contact: {},
        contactName: "",
        position: "",
        contactPhone: "",
        contactEmail: "",
      },
      label: "No Reference",
    });
    if (typeof customerContacts !== "undefined") {
      customerContacts.map((customerContact, index) => {
        contactOptionsTmp.push({
          value: customerContact,
          label: customerContact.contactName,
        });
        if (
          customerContact.standardFlag === true &&
          customerContactDefault === true &&
          values.ID === 0
        ) {
          setFieldValue("contact", customerContact);
          setFieldValue("contactName", customerContact.contactName);
          setFieldValue("position", customerContact.position);
          setFieldValue("contactPhone", customerContact.contactPhone);
          setFieldValue("contactEmail", customerContact.contactEmail);
          handleCustomerContactDefault();
        }
      });
    }
    setContactOptions(contactOptionsTmp);
  }
}

export default QuotationContact;
